// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e40a80b7","239":"3efb3871","453":"79ae65e5","455":"5ce4ef4f"}[chunkId] + ".chunk.js";
};